import Localbase from 'localbase'
let db = new Localbase('dt-local-db');
db.config.debug = false;
export default db;